import { useTranslation } from 'react-i18next';

import starIcon from '@/assets/icons/why-we/star.svg';
import timerIcon from '@/assets/icons/why-we/timer.svg';
import carIcon from '@/assets/icons/why-we/car.svg';
import moneyPigIcon from '@/assets/icons/why-we/money-pig.svg';

import { useScreenType } from '@/hooks/useScreenType';

import { Container } from '@/components/Container';
import { Title } from '@/components/Title';
import { BenefitCard } from '@/components/BenefitCard';
import { Carousel } from '@/components/Carousel';
import { Cloud } from '@/components/Cloud';

import styles from './WhyWe.module.scss';

const BENEFIT_CARDS_ICONS = [
  {
    iconSrc: starIcon,
    iconAlt: 'Star',
  },
  {
    iconSrc: timerIcon,
    iconAlt: 'Timer',
  },
  {
    iconSrc: carIcon,
    iconAlt: 'Car',
  },
  {
    iconSrc: moneyPigIcon,
    iconAlt: 'Money Pig',
  },
];

export function WhyWe() {
  const { t } = useTranslation('whyWe');

  const benefitCardsLocales = t('benefitCards', { returnObjects: true }) as {
    title: string;
    description: string;
  }[];
  const benefitCards = BENEFIT_CARDS_ICONS.map((icon, index) => ({
    iconSrc: icon.iconSrc,
    iconAlt: icon.iconAlt,
    title: benefitCardsLocales[index].title,
    description: benefitCardsLocales[index].description,
  }));

  const { screenType } = useScreenType();
  const isMobileDevice = screenType === 'tablet' || screenType === 'mobile';

  return (
    <section className={styles.whyWe}>
      <Cloud className={styles.whyWe__cloud1} variant={2} />
      <Cloud className={styles.whyWe__cloud2} variant={3} />
      <Container className={styles.whyWe__container}>
        <Title className={styles.whyWe__title}>{t('title')}</Title>
        {!isMobileDevice && (
          <div className={styles.whyWe__cards}>
            {benefitCards.map((card, index) => (
              <BenefitCard
                key={index}
                iconSrc={card.iconSrc}
                iconAlt={card.iconAlt}
                title={card.title}
                description={card.description}
              />
            ))}
          </div>
        )}
        {isMobileDevice && (
          <Carousel
            theme="transparent"
            id="benefit-cards-carousel"
            slidesPerView={screenType === 'tablet' ? 2 : 1}
            spaceBetweenSlides={20}
            slides={benefitCards.map((card, index) => (
              <BenefitCard
                key={index}
                iconSrc={card.iconSrc}
                iconAlt={card.iconAlt}
                title={card.title}
                description={card.description}
              />
            ))}
          />
        )}
      </Container>
    </section>
  );
}
